export function formatPrice(value: number, lang: string, fractionDigits = 2) {
  return formatNumber(value, lang, fractionDigits);
}

export function formatNumber(value: number, lang: string, fractionDigits = 0) {
  const checkedValue = value || 0;
  const parsedValue = Number.parseFloat(checkedValue.toFixed(fractionDigits));
  return parsedValue.toLocaleString(`${lang}-CH`, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
}
